import React, {FC} from "react"
import {Deal} from "@irati/types"

import getId from "@irati/utils/id"
import {isDealUnavailable} from "@irati/deals/helpers/deals/isDealUnavailable"

import DealModes from "../../../enums/DealModes"
import DealHeaderDetails from "../../DealHeaderDetails"
import UnavailableDealHeaderDetails from "../../DealHeaderDetails/UnavailableDealHeaderDetails"
import UnavailableDeal from "./UnavailableDeal"

import {
  AvailableCardDeal,
  UnavailableCardDeal
} from "./styled"

interface Props {
  id?: string,
  deal: Deal,
  mode?: DealModes,
  borderBottomColor: string,
  isFavouriteDeal?: boolean,
  useWalletDealCard?: boolean
}

const DealBody: FC<Props> = ({deal, borderBottomColor, isFavouriteDeal, mode = DealModes.Default, useWalletDealCard, ...props}) => {
  const idNamespace = getId("card", props)
  return (
    <>
      {isDealUnavailable(deal) && (
        <UnavailableCardDeal id={getId("unavailable", idNamespace)}>
          <UnavailableDealHeaderDetails deal={deal} mode={mode} />
          <UnavailableDeal isFavouriteDeal={isFavouriteDeal} />
        </UnavailableCardDeal>
      )}
      {!isDealUnavailable(deal) && (
        <AvailableCardDeal id={getId("available", idNamespace)} borderBottomColor={borderBottomColor}>
          <DealHeaderDetails deal={deal} mode={mode} useWalletDealCard={useWalletDealCard} />
        </AvailableCardDeal>
      )}
    </>
  )
}

export default DealBody
